const fetchSVG = async (url, el) => {
	const response = await fetch(url);
	const data = await response.text();
	const parser = new DOMParser();
	const parsed = parser.parseFromString(data, 'image/svg+xml');

	let svg = parsed.getElementsByTagName('svg');

	if (svg.length) {
		svg = svg[0];

		const attr = svg.attributes;
		const attrLen = attr.length;

		for (let i = 0; i < attrLen; ++i) {
			if (attr[i].specified) {
				if (attr[i].name === 'class') {
					const classes = attr[i].value.replace(/\s+/g, ' ').trim().split(' ');
					const classesLen = classes.length;

					for (let j = 0; j < classesLen; ++j) {
						el.classList.add(classes[j]);
					}
				} else {
					el.setAttribute(attr[i].name, attr[i].value);
				}
			}
		}

		while (svg.childNodes.length) {
			el.appendChild(svg.childNodes[0]);
		}
	}

	return Promise.resolve();
};

const init = () => {
	console.log('init svg')
	const svgs = document.querySelectorAll('svg[data-url]');
	const svgsLen = svgs.length;
	const loadedSVG = [];

	for (let i = 0; i < svgsLen; ++i) {
		let url = svgs[i].getAttribute('data-url');

		svgs[i].removeAttribute('data-url');

		loadedSVG.push(fetchSVG(url, svgs[i]));
	}

	return Promise.all(loadedSVG);
};

export default {
	init,
};
